module.exports = __webpack_public_path__ + "img/shoulderseam.5ff7072c.png";